export default function Footer() {
    return (
        <div className="flex flex-none items-center justify-end bg-brand font-light text-sm px-3 py-[11px] tracking-[0.1px]">
            <a className="no-underline text-[#c6c2ea] flex items-center"
                href="mailto:mail@whoishiring.io">
                <i className="fa fa-envelope-o text-[11px] mr-1" />
                mail@whoishiring.io
            </a>

            <a className="no-underline text-[#c6c2ea] flex items-center text-base ml-4"
                href="https://twitter.com/whoishiringio"
                rel="nofollow noreferrer noopener" target="_blank">
                <i className="fa fa-twitter-square" />
            </a>

            <a className="no-underline text-[#c6c2ea] flex items-center text-base ml-2"
                href="https://www.facebook.com/whoishiringio/"
                rel="nofollow noreferrer noopener" target="_blank">
                <i className="fa fa-facebook-square" />
            </a>
        </div>
    );
}
